import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from '../../../contexts/ThemeContext';

const GraficoTemporal = ({ metricas, loading }) => {
  const { darkMode } = useTheme();

  if (loading) {
    return (
      <div
        className={`p-4 sm:p-6 rounded-lg animate-pulse ${
          darkMode ? 'bg-zinc-800' : 'bg-white'
        }`}
      >
        <div className={`h-4 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded w-1/4 mb-4`}></div>
        <div className={`h-64 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded`}></div>
      </div>
    );
  }

  if (!metricas || metricas.length === 0) {
    return (
      <div
        className={`p-4 sm:p-6 rounded-lg border ${
          darkMode
            ? 'bg-zinc-800 border-gray-700'
            : 'bg-white border-gray-200'
        }`}
      >
        <h3
          className={`text-lg font-semibold mb-4 ${
            darkMode ? 'text-white' : 'text-gray-900'
          }`}
        >
          Evolução Temporal
        </h3>
        <p className={`text-center py-8 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          Nenhum dado disponível para o período selecionado
        </p>
      </div>
    );
  }

  // Formatar dados para o gráfico
  const data = metricas.map((m) => ({
    data: new Date(m.data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    }),
    recebidas: m.mensagens_recebidas,
    enviadas: m.mensagens_enviadas,
    conversas: m.conversas_novas,
    positivo: m.sentimento_positivo || 0,
    neutro: m.sentimento_neutro || 0,
    negativo: m.sentimento_negativo || 0,
  }));

  const temSentimento = data.some(d => d.positivo > 0 || d.neutro > 0 || d.negativo > 0);

  return (
    <div
      className={`p-4 sm:p-6 rounded-lg border ${
        darkMode ? 'bg-zinc-800 border-gray-700' : 'bg-white border-gray-200'
      }`}
    >
      <h3
        className={`text-lg font-semibold mb-4 ${
          darkMode ? 'text-white' : 'text-gray-900'
        }`}
      >
        Evolução Temporal
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid
            strokeDasharray="3 3"
            stroke={darkMode ? '#374151' : '#e5e7eb'}
          />
          <XAxis
            dataKey="data"
            stroke={darkMode ? '#9ca3af' : '#6b7280'}
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke={darkMode ? '#9ca3af' : '#6b7280'}
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: darkMode ? '#1f2937' : '#ffffff',
              border: `1px solid ${darkMode ? '#374151' : '#e5e7eb'}`,
              borderRadius: '8px',
              color: darkMode ? '#ffffff' : '#000000',
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="recebidas"
            stroke="#10b981"
            strokeWidth={2}
            name="Mensagens Recebidas"
            dot={{ fill: '#10b981' }}
          />
          <Line
            type="monotone"
            dataKey="enviadas"
            stroke="#8b5cf6"
            strokeWidth={2}
            name="Mensagens Enviadas"
            dot={{ fill: '#8b5cf6' }}
          />
          <Line
            type="monotone"
            dataKey="conversas"
            stroke="#3b82f6"
            strokeWidth={2}
            name="Conversas Novas"
            dot={{ fill: '#3b82f6' }}
          />
          {temSentimento && (
            <>
              <Line type="monotone" dataKey="positivo" stroke="#10b981" strokeWidth={1.5} strokeDasharray="5 5" name="😊 Positivo" dot={false} />
              <Line type="monotone" dataKey="negativo" stroke="#ef4444" strokeWidth={1.5} strokeDasharray="5 5" name="😞 Negativo" dot={false} />
            </>
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GraficoTemporal;
